export const PROJECT_TYPES = Object.freeze({
    ACTIVE_SELLER: 'ACTIVE SELLER',
    STORY: 'STORY',
});

export const PROJECT_TYPES_OPTIONS = Object.freeze([
    { value: 'ACTIVE SELLER', label: 'Active Seller' },
    { value: 'STORY', label: 'Story' },
]);
